import React, { useEffect, useState } from 'react';
import { View, StatusBar, SafeAreaView, Image, Platform, Dimensions } from 'react-native'

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Pagination, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import CardCarousel from '@vfgroup-oneplatform/foundation/Components/CardCarousel';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes/Provider';

import FrameworkTestKeys from '../FrameworkTestKeys';
import { PreOnboardingTrackingManager } from '../Utils/TrackingManagers';

import TutorialJson from './Config';
import PreOnboardingLottie from './PreOnboardingLottie';
import styles from './PreOnboardingTutorial.Styles';

const lottieSourceJson = require('./PreOnboardingLottie/Tutorial_features.json');

const PreOnboardingTutorial = ({
  steps,
  lottieDurationConfig,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryButtonPress,
  onSecondaryButtonPress,
  renderStep,
  onCardPositionChange,
  initialActiveStep,
  lottieSource,
  images,
  imageProps,
  theme,
  activeStepIndex,
  withSecondaryButton,
  isSwipeDisabled,
  ...props
}) => {
  console.log("🚀 ~ file: PreOnboardingTutorial.js:40 ~ activeStepIndex:", activeStepIndex)
  console.log("🚀 ~ file: PreOnboardingTutorial.js:40 ~ steps:", steps)
  const [activeIndex, setActiveIndex] = useState(initialActiveStep);
  useEffect(() => {
    PreOnboardingTrackingManager.trackView();
  }, []);
  useEffect(() => {
    if (_isFunction(onCardPositionChange)) {
      onCardPositionChange(activeIndex);
    }
  }, [activeIndex]);
  const _renderStep = ({ item, index, isActiveCard }) => {
    console.log(item);
    // if (_isFunction(renderStep)) {
    //   return renderStep({ item, index, isActiveCard });
    // }
    const { title, description, titleStyle, descriptionStyle } = item;
    return (
      <View testID={FrameworkTestKeys.PreOnboardingCard}>
        <VFText
          style={[styles.stepTitleText, titleStyle]}
          i18nKey={title}
          type="primary"
          testKey={FrameworkTestKeys.PreOnboardingCardCarouselTitle}
        />
        <VFText
          style={[styles.stepDescriptionText, descriptionStyle]}
          i18nKey={description}
          type="primary"
          testKey={FrameworkTestKeys.PreOnboardingCardCarouselDescription}
        />
      </View>
    );
  };
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={{ flex: 1, justifyContent: 'space-between' }}>
        <View style={styles.lottieContainer(theme)} pointerEvents="none">
          {images ? (
            <Image source={images[activeStepIndex]} {...imageProps} />
          ) : (
            <PreOnboardingLottie
              lottieDurationConfig={lottieDurationConfig}
              activeIndex={activeIndex}
              lottieSource={lottieSource}
            />
          )}
        </View>
        <View style={styles.contentContainer(theme)}>
          {/* <CardCarousel
            data={steps}
            onSwipe={newActiveIndex => {
              setActiveIndex(newActiveIndex)
            }}
            renderCard={_renderStep}
            duration={300}
            containerStyle={styles.carouselContainer}
            style={styles.cardCarouselStyle}
            initialActiveCard={initialActiveStep}
            activeCardIndex={activeStepIndex}
            isSwipeDisabled={isSwipeDisabled}
          /> */}
          {_renderStep({ item: steps[activeStepIndex] })}
          <Pagination
            activeColor={theme.colors.secondryColor}
            inactiveColor={theme.colors.fillColor}
            inactiveOpacity={1}
            numberOfDots={steps.length}
            activeDotIndex={activeStepIndex}
            containerStyle={styles.paginationContainer}
            testID="preOnboardingPagination"
          />
          <View style={styles.buttonsContainer}>
            <VFButton
              type="primary"
              title={primaryButtonText}
              testID="loginLoginTutorial"
              textAccessibilityLabel="loginLoginTutorial"
              onPress={onPrimaryButtonPress}
              style={{ width: '50%', alignSelf: 'center' }}
            />
            {withSecondaryButton && (
              <VFButton
                type="secondary"
                title={secondaryButtonText}
                onPress={onSecondaryButtonPress}
                style={styles.secondaryButtonStyle(theme)}
                testID="preOnboardingRegisterButton"
              />
            )}
          </View>
        </View>

      </View>
    )
  }
  return (
    <>
      <SafeAreaView style={styles.wrapperContainer(theme)} />
      <SafeAreaView style={styles.container(theme)}>
        <StatusBar
          backgroundColor={theme.colors.statusBarColor}
          barStyle={theme.name === 'light' ? 'dark-content' : 'light-content'}
          translucent
        />
        <View style={styles.lottieContainer(theme)} pointerEvents="none">
          {images ? (
            <Image source={images[activeStepIndex]} {...imageProps} />
          ) : (
            <PreOnboardingLottie
              lottieDurationConfig={lottieDurationConfig}
              activeIndex={activeIndex}
              lottieSource={lottieSource}
            />
          )}
        </View>
        <View style={styles.contentContainer(theme)}>
          {/* <CardCarousel
            data={steps}
            onSwipe={newActiveIndex => {
              setActiveIndex(newActiveIndex);
            }}
            renderCard={_renderStep}
            duration={300}
            containerStyle={styles.carouselContainer}
            style={styles.cardCarouselStyle}
            initialActiveCard={initialActiveStep}
            activeCardIndex={activeStepIndex}
            isSwipeDisabled={isSwipeDisabled}
          /> */}
          {_renderStep({ item: steps[activeStepIndex] })}
          <Pagination
            activeColor={theme.colors.secondryColor}
            inactiveColor={theme.colors.fillColor}
            inactiveOpacity={1}
            numberOfDots={steps.length}
            activeDotIndex={activeStepIndex}
            containerStyle={styles.paginationContainer}
            testID={FrameworkTestKeys.PreOnboardingPagination}
          />
          <View style={styles.buttonsContainer}>
            <VFButton
              type="primary"
              title={primaryButtonText}
              testKey={FrameworkTestKeys.LoginLoginTutorial}
              onPress={onPrimaryButtonPress}
            />
            {withSecondaryButton && (
              <VFButton
                type="secondary"
                title={secondaryButtonText}
                onPress={onSecondaryButtonPress}
                style={styles.secondaryButtonStyle(theme)}
                testID={FrameworkTestKeys.PreOnboardingRegisterButton}
              />
            )}
          </View>
        </View>
      </SafeAreaView>
    </>
  );
};

PreOnboardingTutorial.defaultProps = {
  steps: TutorialJson.steps,
  lottieDurationConfig: TutorialJson.lottieDurationConfig,
  primaryButtonText: TutorialJson.primaryButtonText,
  secondaryButtonText: TutorialJson.secondaryButtonText,
  onPrimaryButtonPress: () => { },
  onSecondaryButtonPress: () => { },
  theme: LightThemeColors,
  initialActiveStep: TutorialJson.initialActiveStep,
  lottieSource: lottieSourceJson,
  withSecondaryButton: true,
};

PreOnboardingTutorial.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  lottieDurationConfig: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number,
      end: PropTypes.number,
    }),
  ),
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  onPrimaryButtonPress: PropTypes.func.isRequired,
  onSecondaryButtonPress: PropTypes.func.isRequired,
  renderStep: PropTypes.func,
  initialActiveStep: PropTypes.number,
  onCardPositionChange: PropTypes.func,
  lottieSource: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  LightThemeColors: PropTypes.object,
  item: PropTypes.object,
  index: PropTypes.number,
  isActiveCard: PropTypes.bool,
  images: PropTypes.array,
  imageProps: PropTypes.object,
  activeStepIndex: PropTypes.number,
  withSecondaryButton: PropTypes.bool,
  isSwipeDisabled: PropTypes.bool,
};

export default withTheme(PreOnboardingTutorial);
